import { Statistic, StatisticProps } from '../Statistic'
import { CurrencyValue, Token } from '@usedapp/core'
import { BigNumber } from 'ethers'
import styled from 'styled-components'
import { AssetIcon } from 'components/atoms/AssetIcon'
import { Text, TextVariant } from 'components/atoms/Text'
import { ValueChange } from 'components/Portfolios/AssetComposition/ValueChange'

interface Props extends Omit<StatisticProps, 'text'> {
  value: BigNumber | undefined
  token: Token
  placeholder?: string
  withTicker?: boolean
  hideIcon?: boolean
  overriderFormatOptions?: Partial<{
    decimals: number
    thousandSeparator: string
    decimalSeparator: string
    significantDigits: number
    useFixedPrecision: boolean
    fixedPrecisionDigits: number
    prefix: string
    suffix: string
  }>
  newValue?: CurrencyValue
  tickerVariant?: TextVariant
}

export function TokenStatistic({
  value,
  token,
  withTicker,
  newValue,
  placeholder = '...',
  overriderFormatOptions,
  hideIcon,
  tickerVariant,
  ...args
}: Props) {
  return (
    <Statistic
      {...args}
      text={
        <Container>
          {value ? (
            <>
              {!hideIcon && <AssetIcon token={token} />}
              {token.format(value.toString(), {
                suffix: undefined,
                ...overriderFormatOptions,
              })}
              {withTicker && (
                <Text variant={tickerVariant} color="light">
                  {token.ticker}
                </Text>
              )}
              {newValue && <ValueChange fixedPrecisionDigits={2} oldValue={value} newValue={newValue} withTicker />}
            </>
          ) : (
            placeholder
          )}
        </Container>
      }
    />
  )
}

export const Container = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`
